import { Heading } from '@sparemin/blockhead';
import React from 'react';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';

export type YouTubeChannelNeededStepProps = {};

const YouTubeChannelNeededStep: React.FC<YouTubeChannelNeededStepProps> = () => {
  return (
    <SocialShareModalBody showRegenerateTextButton={false}>
      <Heading level={2} align="center">
        Your account doesn't have a channel yet, you'll need to create one so
        that we have somewhere to post your videos to.
      </Heading>
    </SocialShareModalBody>
  );
};

export default YouTubeChannelNeededStep;
